import { ILayout, ILayoutConfig, ICell } from "./types";
import { Layout } from "./Layout";
import { ProCell } from "./ProCell";

export class ProLayout extends Layout implements ILayout {
	constructor(parent: any, config: ILayoutConfig) {
		super(parent, config);
	}

	protected _createCell(cell: ILayoutConfig): ICell {
		let view: ICell;
		if (cell.rows || cell.cols || cell.views) {
			cell.parent = this._root;
			view = new ProLayout(this, cell);
		} else {
			view = new ProCell(this, cell);
		}

		// FIxME
		(this._root as any)._all[view.id] = view;
		if (cell.init) {
			cell.init(view, cell);
		}
		return view;
	}
}
